import React, { useCallback } from 'react';

import { ButtonSizes } from '@rbilabs/components-library';
import { useNavigate } from 'react-router';

import { ActionButton } from 'components/action-button';
import { useLoyaltyOffersEmptyStates } from 'hooks/use-loyalty-offers-empty-states';

import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateImage,
  EmptyStateTitle,
} from './favorite-empty-state.styled';

export const FavoritesEmptyState = () => {
  const { offersEmptyStates, offersEmptyStatesLoading } = useLoyaltyOffersEmptyStates();
  const navigate = useNavigate();

  const handleClick = useCallback((link: string) => {
    navigate(link);
  }, []);

  if (offersEmptyStatesLoading || !offersEmptyStates) {
    return null;
  }

  return (
    <EmptyState data-testid="favorite-empty-state">
      <EmptyStateImage
        image={offersEmptyStates.emptyStateFavoriteOffersImage?.locale}
        alt=""
        objectFitContain
      />
      <EmptyStateTitle>{offersEmptyStates.emptyStateFavoriteOffersTitle?.locale}</EmptyStateTitle>
      <EmptyStateDescription>
        {offersEmptyStates.emptyStateFavoriteOffersDescription?.locale}
      </EmptyStateDescription>
      {offersEmptyStates.ctaButtonEmptyStateFavoriteOffersLink?.locale && (
        <ActionButton
          onClick={() =>
            handleClick(offersEmptyStates.ctaButtonEmptyStateFavoriteOffersLink?.locale as string)
          }
          size={ButtonSizes.LARGE}
        >
          {offersEmptyStates.ctaButtonEmptyStateFavoriteOffersText?.locale}
        </ActionButton>
      )}
    </EmptyState>
  );
};
